var _paq = window._paq = window._paq || [];

export function initMatomo() {
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);

  (function() {
    var u = 'https://matomo.mandelbrot.com.br/';
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '1']);

    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type='text/javascript'; g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
  })();
}

export function matomoTrackEvent(category, action, params = null) {
  if (_paq) {
    if (params) {
      _paq.push(['trackEvent', category, action, JSON.stringify(params)]);
    } else {
      _paq.push(['trackEvent', category, action]);
    }
  }
}
